// extracted by mini-css-extract-plugin
export default {"content":"area-setting_page_content__S6FNp","icon":"area-setting_page_icon__1e-Hf","update-input":"area-setting_page_update-input__bkVt2"};